const ProgramComponent = {
    data() {
        return {
            activeTab: 0,
            activeInnerTabs: {},
            activeAccordion: {},
        };
    },

    methods: {
        setTab(index) {
            this.activeTab = index;

            this.activeInnerTabs = {};
            this.activeAccordion = {};

            this.$nextTick(() => {
                this.updateHeights();
            });
        },
        setInnerTab(tabIndex, innerTabIndex) {
            this.activeInnerTabs = {
                ...this.activeInnerTabs,
                [tabIndex]: innerTabIndex,
            };

            Object.keys(this.activeAccordion)
                .forEach((key) => {

                    if (key.startsWith(`${tabIndex}_`)) {
                        delete this.activeAccordion[key];
                    }

                });

            this.$nextTick(() => {
                this.updateHeights();
            });
        },

        toggle(tabIndex, innerTabIndex, accordionIndex) {
            const key =
                `${tabIndex}_${innerTabIndex}`;

            this.activeAccordion[key] =
                this.activeAccordion[key] === accordionIndex
                    ? -1
                    : accordionIndex;

            this.$nextTick(() => {
                this.updateHeights();
            });
        },

        updateHeights() {
            document
                .querySelectorAll('.accordion__content')
                .forEach((content) => {

                    content.style.maxHeight = '0px';

                });

            Object.keys(this.activeAccordion)
                .forEach((key) => {

                    const accordions =
                        this.$refs[`accordion_${key}`];

                    if (!accordions) {
                        return;
                    }

                    const list = Array.isArray(accordions)
                        ? accordions
                        : [accordions];

                    list.forEach((accordion, index) => {

                        const content =
                            accordion.querySelector(
                                '.accordion__content'
                            );

                        if (!content) {
                            return;
                        }

                        if (
                            this.activeAccordion[key]
                            === index
                        ) {
                            content.style.maxHeight =
                                content.scrollHeight + 'px';
                        }

                    });

                });
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.updateHeights();
        });
    },
};

window.ProgramComponent = ProgramComponent;